import { render, staticRenderFns } from "./MilitaryDoc.vue?vue&type=template&id=507c1bde&scoped=true&"
import script from "./MilitaryDoc.vue?vue&type=script&lang=js&"
export * from "./MilitaryDoc.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507c1bde",
  null
  
)

export default component.exports